<template>
  <article class="article">
    <h1 class="article-term" v-if="term">{{ article.term_org }}</h1>
    <p class="article-term">{{ term }}</p>
    <h4 class="article-title">
      <i>{{ article.title }}</i>
    </h4>
    <div v-if="article.keywords" class="article-tags">
      <span v-for="tag in article.keywords">{{ tag.keyword }}</span>
    </div>
    <div v-if="article.links" class="article-links">
      <span v-for="link in article.links">
        <router-link :to="'/article/' + link.id">
          {{ link.term_english }}
        </router-link>
      </span>
    </div>
    <img
      v-if="article.img_url"
      class="article-img"
      :src="'images/' + article.img_url"
    />
    <div class="article-body" v-html="article.text"></div>
    <div class="article-references">
      <h3>BIBLIOGRAPHIC REFERENCES</h3>
      <p v-html="article.references"></p>
    </div>
    <h4 v-if="showAuthor" class="article-author">
      <i> {{ article.author_name }} {{ article.author_surname }}</i
      ><br /><br />
      <p style="font-size: 12px">{{ article.author_affiliation }}</p>
    </h4>

    <p v-if="edition_id" class="article-published">
      Published in Series ... , Vol ... (ou special Edition Nr...), 2019
    </p>
  </article>
</template>

<script>
export default {
  name: "Article",
  props: {
    article: {
      type: Object,
      default: function () {
        return {};
      },
    },
    term: {
      type: String,
      default: "",
    },
    showAuthor: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.article {
  &-term,
  &-title,
  &-links,
  &-tags,
  &-author,
  &-published {
    text-align: center;
    padding: 20px 0;
  }
  &-links,
  &-tags {
    padding: 0 0;
    span {
      display: inline-block;
      margin: 5px 15px;
      background: #fdee21;
      padding: 5px 15px;
    }
  }

  &-img {
    max-height: 300px;
    width: auto;
    margin: 30px auto;
  }

  &-body {
    padding: 30px 0;
    & > div,
    p,
    span {
      color: black;
      text-indent: 50px;
      font-size: 12pt;
    }

    h6 {
      font-size: 11pt;
    }
  }
  &-references {
    padding: 30px 0;
    h3 {
      font-size: 18px;
      text-align: center;
      margin-bottom: 30px;
    }
    p {
      font-size: 11pt;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Article.vue?4c31036c